import { render, staticRenderFns } from "./CoAnimation.vue?vue&type=template&id=7563cf74&scoped=true&"
import script from "./CoAnimation.vue?vue&type=script&lang=js&"
export * from "./CoAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7563cf74",
  null
  
)

export default component.exports